/**
 * @module app.dmeo
 */

import { autoinject } from "aurelia-framework";

/**
 * Returns an string version of a Json object with newline and indents
 * TODO: [MW] Make the indent configurable
 */
@autoinject
export class JsonPrettyValueConverter {

    constructor() { }

    public toView(value: any): string {
        if(value === null || value === undefined) { return ''; }
        try {
            if(typeof value === 'string') {
                value = value.trim();
                value = JSON.parse(value);
            }
            value = JSON.stringify(value, null, 4);
            //value = value.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;');
            return value;
        }
        catch(error) {
            console.log({ jsonify: { error, value } });
            return '';
        }
    }

}
